// extracted by mini-css-extract-plugin
module.exports = {"table":"LoanProfilePropertyIncome_table__3k7o3"};